import React from "react";
import classNames from "classnames";
import Chip from "../Chip/Chip";

const NOMINALS = [ 10000, 5000, 1000, 500, 100, 50, 10, 5, 1 ];
const NOMINALS_REVERSED = NOMINALS.slice().reverse();

export default class Chips extends React.PureComponent {

  decomposite(n, dividers) {
    return dividers.reduce((acc, divider, i) => {
      acc.factors[ i ] = Math.floor(acc.n / divider);
      acc.n = acc.n % divider;
      return acc;
    }, {
      factors: new Array(dividers.length),
      n
    });
  }

  roundValue(x) {
    const n = x > 5000 ? 1000 : (x > 1000 ? 100 : (x > 500 ? 50 : (x > 100 ? 10 : (x > 10 ? 5 : 1))));
    return Math.ceil(x / n) * n;
  }

  render() {
    const { value, className, chipClassName, round, ...rest } = this.props;

    const chipsClasses = classNames(
      "chips",
      className
    );

    let { factors, n } = this.decomposite(round ? this.roundValue(value) : value, NOMINALS);
    factors.reverse();

    return (
      <div className={ chipsClasses } { ...rest }>
        { NOMINALS_REVERSED.map((nominal, i) => (
          factors[ i ] !== 0 &&
          <div className="chips__group" key={ i }>
            { [ ...Array(factors[ i ]) ].map((e, j) => (
              <Chip
                className={ chipClassName }
                value={ nominal }
                key={ `${nominal}-${j}` }
                style={ {
                  left: (-1 * j) + "px",
                  top: (-2 * j) + "px",
                  zIndex: 100 + (i * j + j)
                } }
              />
            )) }
          </div>
        )) }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Chips/Chips.jsx